import { commitMutation,
  graphql } from 'react-relay';
import environment from '..';
import { basicMutationOnCompleted, onErrorMutation } from './common/common';

const mutation = graphql`
mutation SendInvitationEmailMutation($email: String!) {
  sendInvitationEmail(email: $email) {
    ok
    error
  }
}
`;

export default ({ email }, done) => {
  const variables = { email };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ sendInvitationEmail }) => basicMutationOnCompleted(sendInvitationEmail, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
